<template>
  <div class="flex">
    <SplitButton
      label="Crear Usuario"
      icon="pi pi-plus"
      @click="createUser"
      :model="items"
      severity="primary"
      class="mt-2"
    />
    <input
      type="file"
      ref="fileInput"
      style="display: none"
      accept=".xlsx"
      @change="onFileSelect"
    />
  </div>
</template>

<script setup lang="ts">
  import { ref } from 'vue'
  import {
    getBulkTemplateByCode,
    uploadBulkSupervisors,
  } from '@/shared/services/fileService'
  import useNotifications from '@/store/notification'
  import useLoading from '@/store/load'
  import { useRouter } from 'vue-router'

  const notificationStore = useNotifications()
  const loadingStore = useLoading()
  const fileInput = ref<HTMLInputElement | null>(null)
  const router = useRouter()

  const createUser = () => {
    router.push('/users/add')
  }

  const items = ref([
    {
      label: 'Descargar Plantilla',
      icon: 'pi pi-download',
      command: () => {
        downloadTemplate()
      },
    },
    {
      label: 'Cargar Plantilla',
      icon: 'pi pi-upload',
      command: () => {
        fileInput.value?.click()
      },
    },
  ])

  const downloadTemplate = async () => {
    loadingStore.setLoadingState()
    await getBulkTemplateByCode('PCS01')
    loadingStore.dismissLoadingState()
  }

  const onFileSelect = (event: Event) => {
    const target = event.target as HTMLInputElement
    if (target.files && target.files.length > 0) {
      const file = target.files[0]
      uploadFile(file)
    }
    // Reset the input value to allow uploading the same file again
    if (fileInput.value) {
      fileInput.value.value = ''
    }
  }

  const uploadFile = async (file: File) => {
    loadingStore.setLoadingState()
    try {
      // const webhookUrl = `${import.meta.env.BASE_URL}/webhook/bulk-creation-status`
      const response = await uploadBulkSupervisors(
        file,
        'https://next-auto.nominasaps.com/users'
      )
      notificationStore.addSuccesNotification({
        summary: 'Carga exitosa',
        detail: response.message,
        severity: 'success',
      })
    } catch (error: any) {
      if (
        error.response &&
        error.response.data.type ===
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      ) {
        // Handle file download error
        const url = window.URL.createObjectURL(new Blob([error.response.data]))
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', 'bulk_supervisors_errors.xlsx')
        document.body.appendChild(link)
        link.click()
        link.parentNode?.removeChild(link)
        notificationStore.addErrorNotification({
          summary: 'Error en la validación',
          detail: 'Se ha descargado un archivo con los errores encontrados.',
          severity: 'info',
        })
      }
    } finally {
      loadingStore.dismissLoadingState()
    }
  }
</script>
